import AHCREventsView from 'features/ahcr-events/components/ahcr-event-view'
import AlarmsView from 'features/alarms/components/alarms-view'
import ANPREventsView from 'features/anpr-events/components/anpr-event-view'
import CameraHealthView from 'features/cameras/components/camera-health-view'
import CamerasView from 'features/cameras/components/cameras-view'
import PlateHistoryView from 'features/anpr-events/components/plate-history-view'
import DashboardView from 'features/dashboard/components/dashboard-view'
import HealthView from 'features/health/components/health-view'
import CameraMapView from 'features/map/components/camera-map-view'
import SettingsView from 'features/settings/components/settings-view'
import SigninView from 'features/sign-in/components/signin-view'
import StreamView from 'features/stream/components/stream-view'
import UsersView from 'features/users/components/users-view'
import { Navigate, Route, Routes } from 'react-router-dom'

const AppRoutes = () => {
  return (
    <Routes>
      <Route
        path='/'
        element={<DashboardView />}
      />
      <Route
        path='/signin'
        element={<SigninView />}
      />
      <Route
        path='/users'
        element={<UsersView />}
      />
      <Route
        path='/anpr-events'
        element={<ANPREventsView />}
      />
      <Route
        path='/ahcr-events'
        element={<AHCREventsView />}
      />
      <Route
        path='/alarms'
        element={<AlarmsView />}
      />
      <Route
        path='/cameras'
        element={<CamerasView />}
      />
      <Route
        path='/stream'
        element={<StreamView />}
      />
      <Route
        path='/map'
        element={<CameraMapView />}
      />
      <Route
        path='/camera-health'
        element={<CameraHealthView />}
      />
      <Route
        path='/plate-history'
        element={<PlateHistoryView />}
      />
      <Route
        path='/health'
        element={
          <HealthView />
        }
      />
      <Route
        path='/settings'
        element={<SettingsView />}
      />
      <Route
        path='*'
        element={
          <Navigate
            to='/'
            replace
          />
        }
      />
    </Routes>
  )
}

export default AppRoutes
